import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { getAssetUrl } from '../helper/assets';
import styled from 'styled-components';
import { colors } from './common/element/elements.js';
import HomeDatas from '../data/pages/home.json';

const Styles = styled.div`
    .steps-section-area {
        padding: 63px 0 42px;
        background: #ffffff;

        .sec-title {
            h4 {
                color: ${colors.black1};
                line-height: 35px;
                font-weight: 600;
                max-width: 650px;
                margin: auto;
                margin-bottom: 48px;

                @media(max-width: 575px) {
                    margin-bottom: 25px;
                    font-size: 20px;
                }
            }
        }

        .steps-image-container {
            text-align: center;
            img {
                max-width: 100%;
                height: auto;
                border-radius: 5px;
                box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
            }
        }
    }
`;

function StepsSection() {
    const stepsData = HomeDatas.stepsSection;

    return (
        <Styles>
            <section className="steps-section-area">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="sec-title text-center">
                                <h4>{stepsData.secTitle}</h4>
                            </div>
                        </Col>
                        <Col md="12">
                            <div className="steps-image-container">
                                <img src={getAssetUrl(stepsData.imagePath)} alt={stepsData.secTitle} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    );
}

export default StepsSection;
